import { useMsal } from '@azure/msal-react';
import React from 'react'
import { Popover, PopoverContent, PopoverTrigger } from 'src/components/ui/popover'

const ProfilePicture = () => {
    const { instance, accounts } = useMsal();

    const handleLogout = (logoutType:string) => {
        if (logoutType === "popup") {
            instance.logoutPopup({
                postLogoutRedirectUri: "/",
                mainWindowRedirectUri: "/"
            });
        } else if (logoutType === "redirect") {
            instance.logoutRedirect({
                postLogoutRedirectUri: "/",
            });
        }
    }

  return (
    <Popover>
        <PopoverTrigger><div className='w-8 min-w-8 h-8 rounded-full border border-neutral-500 flex items-center justify-center'><p className='text-sm'>{accounts[0]?.name?.charAt(0)}</p></div></PopoverTrigger>
        <PopoverContent className='p-0'>
            <div className='flex justify-between items-center'>
                <p className='p-4 text-sm font-medium'>FITdoc</p>
            </div>
            <div className='flex gap-4 p-4'>
                <div className='w-20 min-w-20 h-20 border-solid border border-neutral-500 flex items-center justify-center rounded-full'><p className='text-2xl'>{accounts[0]?.name?.charAt(0)}</p></div>
                <div>
                    <p className='text-xl font-semibold line-clamp-1'>{accounts[0]?.name}</p>
                    <p className='text-sm line-clamp-1'>{accounts[0]?.username}</p>
                </div>
            </div>
            <button onClick={()=>handleLogout("popup")} className='bg-slate-100 py-5 w-full text-sm hover:bg-slate-200'>
                Uitloggen
            </button>
        </PopoverContent>
    </Popover>
  )
}

export default ProfilePicture